const footerLinks = [
  { label: '首页', href: '#hero' },
  { label: '热门专题', href: '#carousel' },
  { label: '平台优势', href: '#features' },
  { label: '关于我们', href: '#about' },
  { label: '精选推荐', href: '#cards' },
  { label: '常见问题', href: '#faq' },
  { label: '联系我们', href: '#contact' },
];

export default function Footer() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-foreground-900 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-circle-fill text-white text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold">宅男视频</span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              宅男视频品牌聚合香蕉视频、红桃视频、蜜桃视频、樱花视频等热门平台，
              提供宅男专属的高清免费在线观看体验。覆盖海量影视与热门合集，专为男性用户打造。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-bold mb-4 text-white">快速导航</h3>
            <ul className="space-y-2">
              {footerLinks.slice(0, 4).map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      handleClick(link.href);
                    }}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold mb-4 text-white">更多链接</h3>
            <ul className="space-y-2">
              {footerLinks.slice(4).map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      handleClick(link.href);
                    }}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold mb-4 text-white">合作伙伴</h3>
            <p className="text-sm text-foreground-400 leading-relaxed mb-3">
              感谢以下合作伙伴的支持
            </p>
            <div className="space-y-1.5">
              <p className="text-xs text-foreground-500">香蕉视频 · 红桃视频</p>
              <p className="text-xs text-foreground-500">蜜桃视频 · 樱花视频</p>
              <p className="text-xs text-foreground-500">更多伙伴持续加入中</p>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 宅男视频 版权所有
          </p>
          <p className="text-xs text-foreground-500">
            本站内容仅供学习交流，请勿用于商业用途
          </p>
        </div>
      </div>
    </footer>
  );
}